import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { Form, Field } from "react-final-form";
import { Grid } from "@mui/material";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import { createValidationCodeWithoutBiometryMutation } from '../../action';

const ParaClinicalVerificationDialog = ({ 
    insureeId, 
    hfId, 
    showDialog, 
    setShowDialog,
    setOpenSnackbar,
    setSnackbarMessage,
    setSeverity, 
}) => {
    const [mutating, setMutating] = useState(false);
    const { t } = useTranslation()
    
    const handleClose = () => {
        setShowDialog(false);
    };

    const validate = (values) => {
        const errors = {};
        if (!values.clinicalVerificationCode) {
            errors.clinicalVerificationCode = t("Field is required");
        }
        return errors;
    };

    const onSubmit = async (values) => {
        setSeverity("success")
        setMutating(true)
        try {
            const response = await createValidationCodeWithoutBiometryMutation({
                clinicalVerificationCode: values.clinicalVerificationCode,
                insureeId,
                hfId
            })
            if(response?.success) { 
                setSnackbarMessage("Code de vérification créé avec succès") 
                setShowDialog(false) 
            } else {
                setSnackbarMessage(response?.message)
                setSeverity("error")
            }
        } catch(error) {
            setSeverity("error")
            setSnackbarMessage("Erreur lors de la création du code de vérification")
        }
        setOpenSnackbar(true)
        setMutating(false)
    };

    return (
        <React.Fragment>
            <Dialog
                open={showDialog}
            >
                <DialogTitle>{t("Verify")}</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item>
                            <Grid container>
                                <Form
                                    onSubmit={onSubmit}
                                    validate={validate}
                                    render={({
                                        handleSubmit,
                                        form,
                                        submitting,
                                        pristine,
                                        values,
                                        errors,
                                    }) => (
                                        // setFormValues(values),
                                        <form onSubmit={handleSubmit}>
                                            <Grid container>
                                                <Grid item xs={12} className="common-input" style={{ marginTop: "2px" }}>
                                                    <Field
                                                        name="clinicalVerificationCode"
                                                        component={TextInput}
                                                        label={t("ClinicalVerificationCode")}
                                                        // required
                                                        type="text"
                                                    />
                                                </Grid>
                                            </Grid>
                                            <DialogActions>
                                                <Button onClick={handleClose}>{t("cancel")}</Button>

                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    disabled={submitting || mutating || pristine || Object.keys(errors).length > 0}
                                                >
                                                    {"Confirmer"}
                                                </Button>
                                            </DialogActions>
                                        </form>
                                    )}

                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>

            </Dialog>

        </React.Fragment>
    );
}
export default ParaClinicalVerificationDialog